module.exports = __webpack_public_path__ + "img/duke-club-logo-white.7eb545eb.png";